import Vue from 'vue'
import Vuex from 'vuex'
//import createPersistedState from "vuex-persistedstate";
import {cmpProjs} from './modules/cmpProjs/index'
import {applies} from './modules/applies/index'
import {invites} from './modules/invites/index'
import {setting} from './modules/setting/index'
// import {posts} from './modules/posts/index'
import {commons} from './modules/commons/index'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        cmpProjs,
        applies,
        invites,
        setting,
        // posts,
        commons
    },
    //plugins: [createPersistedState({storage: window.sessionStorage, key: 'tech.promeraia'})],
})
